<template>
    <div v-if="answer">
        <div :class="{field_with_errors: formChangedAndInvalid}">
            <textarea name="answer[content]" class="answer-form__input" v-model.trim="answer.content" spellcheck="true" :maxlength="answerMaxLength"></textarea>
        </div>
        <files-list v-model="answer.files">
            <template slot="actions">
                <submit-trigger-button v-if="submitButton" class="btn btnMd btnRed" event-to-trigger="submitAnswerEditForm" :eventId="eventId">Post answer</submit-trigger-button>
            </template>
        </files-list>
    </div>
</template>
<script>
import SubmitTriggerButton from '../../shared/SubmitTriggerButton'
import FilesList from './FilesList'
import api from './api'

    export default {
        name: 'AnswerForm',
        components: {
            SubmitTriggerButton, FilesList
        },
        props: ['editableAnswerId', 'submitButton', 'eventId', 'cachedSlug'],
        data: function () {
            return {
                answer: {
                    files: {
                        files: [],
                        deleted: []
                    },
                    content: ''
                },
                answerMaxLength: Grabcad.AttributeLimits.Generic.CONTENT_BODY,
                saveRequestInProgress: false,
                submitAttempted: false
            };
        },
        computed: {
            submissionDisabled: function () {
                return this.saveRequestInProgress;
            },

            formValid: function () {
                return this.answer.content.length > 0;
            },

            formChangedAndInvalid: function () {
                return this.submitAttempted && !this.formValid;
            }
        },
        methods: {
            getAnswerForEditing: function (id) {
                api.fetchAnswer(id, this.cachedSlug)
                    .then(this.setAnswer)
                    .catch(this.handleRequestError);
            },

            setAnswer: function (response) {
                this.$set(this.answer, 'content', response.content);
                this.$set(this.answer, 'id', response.id);
                this.$set(this.answer.files, 'files', response.files);
            },

            handleRequestError: function (err) {
                this.$eventHub.$emit('addAlert', {
                    type: 'error',
                    message: err.response.status === 413 ? 'The uploaded attachment is too large. Please try again' : 'Something went wrong'
                });
                Raygun && Raygun.send(err);
            },

            submitForm: function (eventId) {
                if (this.eventId !== eventId) return;

                this.submitAttempted = true;
                if (!this.formValid) {
                    this.$eventHub.$emit('validationError');
                    return;
                }
                this.setRequestState();

                api.createUpdateAnswer(this.answer, this.cachedSlug)
                    .then(this.afterRequest)
                    .catch(this.handleRequestError)
                    .finally(this.clearRequestState);
            },

            afterRequest: function (response) {
                location.hash = "answer-" + response.answer_id;
                location.reload();
            },

            setRequestState: function () {
                this.saveRequestInProgress = true;
                let timeout = 30000;
                setTimeout(this.clearRequestState, timeout);
            },

            clearRequestState: function () {
                this.saveRequestInProgress = false;
            }
        },
        mounted: function () {
            if (this.editableAnswerId) {
                this.getAnswerForEditing(this.editableAnswerId);
            }
            this.$eventHub.$on('submitAnswerEditForm', this.submitForm);
        }
    }
</script>
